var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageNotice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2155_499)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8991 20.7996V3.20037C17.8991 2.53737 17.3621 2.00037 16.6991 2.00037H6.8993L0.899902 8.00037V20.7996C0.899902 21.4626 1.4369 21.9996 2.0999 21.9996H16.6991C17.3621 21.9996 17.8991 21.4626 17.8991 20.7996Z",
    fill: "#C0C7D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.6999 8.00037H0.899902L6.8993 2.00037V6.80037C6.8993 7.46337 6.3623 8.00037 5.6993 8.00037H5.6999Z",
    fill: "#C0C7D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.6999 8.00037H0.899902L6.8993 2.00037V6.80037C6.8993 7.46337 6.3623 8.00037 5.6993 8.00037H5.6999Z",
    fill: "#ADB3BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2744 8.90307L9.77344 17.4041L12.9978 20.6285L21.4988 12.1275L18.2744 8.90307Z",
    fill: "#FFAA00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8296 10.7964L21.4988 12.1272L18.2744 8.90281L19.6046 7.57261C19.9646 7.21261 20.5478 7.21261 20.9078 7.57261L22.829 9.49381C23.189 9.85381 23.189 10.437 22.829 10.797L22.8296 10.7964Z",
    fill: "#FF9000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.02729 21.6924L10.6029 21.27L9.13169 19.7982L8.70929 21.3744C8.65769 21.5676 8.83409 21.744 9.02729 21.6924Z",
    fill: "#313D4C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.13184 19.7982L10.6036 21.27L12.9982 20.628L9.77384 17.4042L9.13184 19.7982Z",
    fill: "#FFCCA8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2155_499"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageNotice);
export default __webpack_public_path__ + "static/media/manageNotice.5001abf87992c2ded920ced16b804359.svg";
export { ForwardRef as ReactComponent };